<template>
  <footer class="footer">
    <div class="container">
      <p>Copyright  © 2025 伟晟达技术开发&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="beian" @click="beian" style="color:blue">备案号：辽ICP备2025048399号-1</span></p>
      <!-- <ul>
        <li><a href="/terms">条款</a></li>
        <li><a href="/privacy">隐私政策</a></li>
      </ul> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    beian() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #f0f0f0;
  color: #333;
  padding: 10px 0;
  text-align: center;
}

.container {
  justify-content: space-between;
  align-items: center;
}

.beian:hover {
  cursor: pointer; /* 悬停时光标形状为手指 */
}

footer ul {
  list-style-type: none;
  padding: 0;
}

footer ul li {
  display: inline;
  margin-left: 10px;
}

footer ul li a {
  color: #333;
  text-decoration: none;
}
</style>